import { Component } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { Storage } from '@ionic/storage';
import {ViewController, NavParams} from 'ionic-angular';

import { applicationLifetimeStorageName, kenntnisnahmeKey, kenntnisnahmeSpeicherwert } from '../../app/core/GlobalValues';
import { eGENA_Rechtliches } from '../../visionet/Rechtliches';
import { GlobalsSingleton } from '../../app/core/GlobalsSingleton';

import { GlobalConstants } from '../../app/core/GlobalConstants';



@Component({
  templateUrl: 'HaftungsausschlussPopup.html'
})
export class HaftungsausschlussPopup {

	zeigeCheckbox : boolean = false;
	haftungsausschluss : SafeHtml = ""; // Das wird dargestellt.


	constructor(public viewCtrl: ViewController, public navParams: NavParams, public globals: GlobalsSingleton, public storage: Storage, public sanitizer: DomSanitizer) {
		this.zeigeCheckbox = this.navParams.get('zeigeCheckbox');

		this.storage.get(GlobalConstants.STORAGE_KEY_RECHTLICHES)
			.then((rechtliches : eGENA_Rechtliches) => {
				// Wir manipulieren die externen Links so, dass sie in einem separaten Browser-Fenster geöffneet werden
				if (!rechtliches)
					this.haftungsausschluss = this.sanitizer.bypassSecurityTrustHtml(globals.translate("ERR.Kein Haftungsausschluss"));
				else
					this.haftungsausschluss = this.sanitizer.bypassSecurityTrustHtml(rechtliches?.Haftungsausschluss.replace(/<a/gi, "<a target=\"_\" "));

			})
			.catch( (reason: any) => {
				this.haftungsausschluss = globals.translate("ERR.Kein Haftungsausschluss");
				console.error("Haftungsausschluss ermitteln Fehler: " + reason);
			});
	}


  close() {
    this.viewCtrl.dismiss();
  }

  

  setChecked() : void {
	let applicationLifetimeStorage = new Storage({
		name: applicationLifetimeStorageName,
		storeName: applicationLifetimeStorageName,
		driverOrder: ['indexeddb', 'sqlite', 'websql', 'localstorage']
	});

	/* #14672 */
	console.info("Kenntnisnahme-Speicher " + applicationLifetimeStorageName + " wird gelöscht...");
	// Machen wir wegen Safari, weil anscheinend bereits die vorherige Abfrage einen Wert gesetzt hat.
	applicationLifetimeStorage.clear()
	.then(() => {
		console.log("Ich speichere jetzt den '" + kenntnisnahmeKey + "' im '" + applicationLifetimeStorageName + "'")
		applicationLifetimeStorage.set(kenntnisnahmeKey, kenntnisnahmeSpeicherwert)
		.then(() => {
			console.info("Kenntnisnahme permanent gespeichert");
		})
		.catch((e : any) => {
			console.error("Fehler beim Speichern der Kenntnisnahme");
		});
	})
	.catch((e : any) => {
		console.error("Fehler beim Löschen des " + applicationLifetimeStorageName);
	});

    this.viewCtrl.dismiss();
	}
}



// WEBPACK FOOTER //
// ./src/components/popups/HaftungsausschlussPopup.ts